"use strict";

var __awaiter = this && this.__awaiter || function (s, o, c, a) {
  return new (c || (c = Promise))(function (e, t) {
    function r(e) {
      try {
        i(a.next(e));
      } catch (e) {
        t(e);
      }
    }

    function n(e) {
      try {
        i(a.throw(e));
      } catch (e) {
        t(e);
      }
    }

    function i(t) {
      t.done ? e(t.value) : new c(function (e) {
        e(t.value);
      }).then(r, n);
    }

    i((a = a.apply(s, o || [])).next());
  });
},
    __generator = this && this.__generator || function (r, n) {
  var i,
      s,
      o,
      e,
      c = {
    label: 0,
    sent: function sent() {
      if (1 & o[0]) throw o[1];
      return o[1];
    },
    trys: [],
    ops: []
  };
  return e = {
    next: t(0),
    throw: t(1),
    return: t(2)
  }, "function" == typeof Symbol && (e[Symbol.iterator] = function () {
    return this;
  }), e;

  function t(t) {
    return function (e) {
      return function (t) {
        if (i) throw new TypeError("Generator is already executing.");

        for (; c;) {
          try {
            if (i = 1, s && (o = 2 & t[0] ? s.return : t[0] ? s.throw || ((o = s.return) && o.call(s), 0) : s.next) && !(o = o.call(s, t[1])).done) return o;

            switch (s = 0, o && (t = [2 & t[0], o.value]), t[0]) {
              case 0:
              case 1:
                o = t;
                break;

              case 4:
                return c.label++, {
                  value: t[1],
                  done: !1
                };

              case 5:
                c.label++, s = t[1], t = [0];
                continue;

              case 7:
                t = c.ops.pop(), c.trys.pop();
                continue;

              default:
                if (!(o = 0 < (o = c.trys).length && o[o.length - 1]) && (6 === t[0] || 2 === t[0])) {
                  c = 0;
                  continue;
                }

                if (3 === t[0] && (!o || t[1] > o[0] && t[1] < o[3])) {
                  c.label = t[1];
                  break;
                }

                if (6 === t[0] && c.label < o[1]) {
                  c.label = o[1], o = t;
                  break;
                }

                if (o && c.label < o[2]) {
                  c.label = o[2], c.ops.push(t);
                  break;
                }

                o[2] && c.ops.pop(), c.trys.pop();
                continue;
            }

            t = n.call(r, c);
          } catch (e) {
            t = [6, e], s = 0;
          } finally {
            i = o = 0;
          }
        }

        if (5 & t[0]) throw t[1];
        return {
          value: t[0] ? t[1] : void 0,
          done: !0
        };
      }([t, e]);
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var rxjs_1 = require("rxjs"),
    ts_md5_1 = require("ts-md5"),
    InitialisationResponse_1 = require("../model/InitialisationResponse"),
    ScriptResponse_1 = require("../model/ScriptResponse"),
    ScriptStatus_1 = require("../model/ScriptStatus"),
    DataManager = function () {
  function e(e) {
    this.sdk = e, this.subject = new rxjs_1.Subject(), this.decoderScript = null, this.configData = null, this.isScriptLoaded = !1, this.forceOffline = !1;
  }

  return e.prototype.isOnline = function () {
    return this.sdk.getConnectivity().isOnline() && !this.isForceOffline();
  }, e.prototype.isForceOffline = function () {
    return this.forceOffline;
  }, e.prototype.setForceOffline = function () {
    this.forceOffline = !0;
  }, e.prototype.postprocessInitialisation = function (t) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (e) {
        switch (e.label) {
          case 0:
            return this.configData = new InitialisationResponse_1.InitialisationResponse(t), this.configData.offlineConfig ? [4, this.loadAndStoreScript()] : [2];

          case 1:
            return e.sent(), this.createScript(), [2];
        }
      });
    });
  }, e.prototype.fetch = function (r, n) {
    return __awaiter(this, void 0, void 0, function () {
      var t;
      return __generator(this, function (e) {
        switch (e.label) {
          case 0:
            return t = this.sdk.getServerUrl() + r, "/decode" !== r ? [3, 2] : [4, this.fetchDetection(t, n)];

          case 1:
            return [2, e.sent()];

          case 2:
            return [4, this.fetchGeneric(t, n)];

          case 3:
            return [2, e.sent()];
        }
      });
    });
  }, e.prototype.initialiseDecoder = function (e, t) {
    try {
      prismaidoffline.initialiseDecoder(e, t), this.subject.next(new ScriptResponse_1.ScriptResponse(ScriptStatus_1.ScriptStatus.ready));
    } catch (e) {
      console.log("initialiseDecoder failed"), this.subject.next(new ScriptResponse_1.ScriptResponse(ScriptStatus_1.ScriptStatus.failed));
    }
  }, e.prototype.fetchGeneric = function (s, o) {
    return __awaiter(this, void 0, void 0, function () {
      var t, r, n, i;
      return __generator(this, function (e) {
        switch (e.label) {
          case 0:
            if (!this.isOnline()) return [3, 7];
            e.label = 1;

          case 1:
            return e.trys.push([1, 5,, 6]), [4, fetch(s, o)];

          case 2:
            return 200 !== (t = e.sent()).status ? [3, 4] : [4, t.json()];

          case 3:
            return r = e.sent(), localStorage.setItem(s + "_" + this.sdk.getAPIKey(), JSON.stringify(r)), [2, r];

          case 4:
            return [3, 6];

          case 5:
            return n = e.sent(), console.log("fetchGeneric failed:", n), [3, 6];

          case 6:
            return [3, 8];

          case 7:
            return i = localStorage.getItem(s + "_" + this.sdk.getAPIKey()), [2, JSON.parse(i)];

          case 8:
            return [2, null];
        }
      });
    });
  }, e.prototype.fetchDetection = function (s, o) {
    return __awaiter(this, void 0, void 0, function () {
      var t, r, n, i;
      return __generator(this, function (e) {
        switch (e.label) {
          case 0:
            if (!this.isOnline()) return [3, 6];
            e.label = 1;

          case 1:
            return e.trys.push([1, 4,, 5]), [4, fetch(s, o)];

          case 2:
            return [4, (t = e.sent()).json()];

          case 3:
            return n = e.sent(), [2, {
              status: t.status,
              data: n
            }];

          case 4:
            return r = e.sent(), console.log("fetchDetection failed:", r), [3, 5];

          case 5:
            return [3, 11];

          case 6:
            n = {}, e.label = 7;

          case 7:
            return e.trys.push([7, 9,, 10]), [4, prismaidoffline.handleDecodeRequest(JSON.parse(o.body))];

          case 8:
            return n = e.sent(), [3, 10];

          case 9:
            return i = e.sent(), console.log("fetchDetection|handleDecodeRequest failed:", i), [3, 10];

          case 10:
            return [2, {
              status: n.errorCode ? 400 : 200,
              data: n
            }];

          case 11:
            return [2];
        }
      });
    });
  }, e.prototype.loadAndStoreScript = function () {
    return __awaiter(this, void 0, void 0, function () {
      var t, r, n, i;
      return __generator(this, function (e) {
        switch (e.label) {
          case 0:
            if (t = this.configData.offlineConfig.moduleUrl, !this.isOnline()) return [3, 6];
            e.label = 1;

          case 1:
            return e.trys.push([1, 4,, 5]), [4, fetch(t, {
              mode: "cors"
            })];

          case 2:
            return r = e.sent(), n = this, [4, r.text()];

          case 3:
            return n.decoderScript = e.sent(), localStorage.setItem("offlineModule", this.decoderScript), [3, 5];

          case 4:
            return i = e.sent(), console.log("storeScript failed:", i), [3, 5];

          case 5:
            return [3, 7];

          case 6:
            this.decoderScript = localStorage.getItem("offlineModule"), e.label = 7;

          case 7:
            return [2];
        }
      });
    });
  }, e.prototype.createScript = function () {
    var t = this;

    if (!this.isScriptLoaded && null !== this.decoderScript) {
      var e = new Blob([this.decoderScript], {
        type: "application/javascript"
      }),
          r = URL.createObjectURL(e),
          n = document.createElement("script");
      n.type = "module", n.src = r, n.onload = function () {
        URL.revokeObjectURL(r), t.isScriptLoaded = !0, t.subject.next(new ScriptResponse_1.ScriptResponse(ScriptStatus_1.ScriptStatus.loaded)), t.initialiseDecoder(t.sdk.getAPIKey(), t.configData);
      }, n.onerror = function (e) {
        URL.revokeObjectURL(r), console.log("script error:", e), t.subject.next(new ScriptResponse_1.ScriptResponse(ScriptStatus_1.ScriptStatus.error));
      }, document.getElementsByTagName("head")[0].appendChild(n);
    }
  }, e.prototype.checkModuleSignature = function () {
    var e = ts_md5_1.Md5.hashStr(this.decoderScript),
        t = e === this.configData.offlineConfig.moduleSignature;
    return console.log("moduleSignature (" + e + ") is " + (t ? "valid" : "invalid")), t;
  }, e;
}();

exports.DataManager = DataManager;